import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Box, Grid } from "@material-ui/core";
import PrimaryButton from "./PrimaryButton";
import PartnerList from "./PartnerList";
import { FormattedMessage } from "react-intl";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        boxLine: {
            border: '1px solid #ebdcc6',
            borderRadius: '4px',
            boxShadow: 'none',
            padding: 10,
            backgroundColor: '#ffffff'
        },
        boxTitle: {
            paddingBottom: 10,
            paddingTop: 10,
            fontWeight: 'bold',
            fontSize: '18px'
        },
        largeTitle: {
            paddingBottom: 15,
            fontWeight: 'bold',
            fontSize: '25px'
        },
        text: {
            fontSize: '14px',
            lineHeight: '25px'
        }
    }),
);

const partners = {
    "telecommunications": [
        { "name": "Qubix", "image": "qubix.png" },
        { "name": "Triton", "image": "triton.png" },
        { "name": "HW Group", "image": "hwgroup.png" },
        { "name": "Effekta", "image": "effekta.png" },
        { "name": "Kamax Europe", "image": "kamax.png" },
        { "name": "BACHMANN", "image": "bachmann.png" },
        { "name": "Brother", "image": "brother.png" },
        { "name": "KDP", "image": "kdp.png" },
        { "name": "Yeastar", "image": "yeastar.png" },
        { "name": "Sticklers", "image": "sticklers.png" },
        { "name": "ASSMANN", "image": "assmann.png" },
        { "name": "Digitus Professional", "image": "digitus.png" },
        { "name": "EdNet", "image": "ednet.png" },
        { "name": "Toten", "image": "toten.png" },
        { "name": "Teracom", "image": "teracom.png" },
        { "name": "KSTART", "image": "kstar.png" },
        { "name": "OFS", "image": "ofs.png" },
        { "name": "Silver FOX", "image": "silverfox.png" },
        { "name": "DYMO", "image": "dymo.png" },
        { "name": "Mirsan", "image": "mirsan.png" },
        { "name": "Yealink", "image": "yealink.png" },
        { "name": "LASCAR Electronics", "image": "lascar.png" }
    ],
    "security": [
        { "name": "Dahua", "image": "dahua.png" },
        { "name": "DetectoMat", "image": "detectomat.png" },
        { "name": "TOA", "image": "toa.png" },
        { "name": "Global Fire Equipment", "image": "global.png" },
        { "name": "Synaps", "image": "synaps.png" },
        { "name": "Inim Electronics", "image": "inim.png" },
        { "name": "Bentel Security", "image": "bentel.png" },
        { "name": "Satel", "image": "satel.png" },
        { "name": "DSC", "image": "dsc.png" },
        { "name": "Cofem", "image": "cofem.png" },
        { "name": "Detector Testers", "image": "detectortesters.png" },
        { "name": "STI", "image": "sti.png" },
        { "name": "Ultracell", "image": "ultracell.png" },
        { "name": "MERAWEX", "image": "merawex.png" }
    ],
    "materials": [
        { "name": "EFAPEL", "image": "efapel.png" },
        { "name": "HYUNDAI", "image": "hyundai.png" },
        { "name": "BAKS", "image": "baks.png" },
        { "name": "Draka", "image": "draka.png" },
        { "name": "NVENT ERICO", "image": "nvent.png" },
        { "name": "Spamel", "image": "spamel.png" },
        { "name": "EVOPIPES", "image": "evopipes.png" },
        { "name": "ABB", "image": "abb.png" },
        { "name": "Elettro Kanali", "image": "elettrocanali.png" },
        { "name": "Algodue", "image": "algodue.png" },
        { "name": "JSL", "image": "jsl.png" },
        { "name": "Geros", "image": "geros.png" },
        { "name": "Dietzel Univolt", "image": "dietzel.png" },
        { "name": "Mirsan", "image": "mirsan.png" },
        { "name": "EUPEN", "image": "eupen.png" },
        { "name": "LIET Kabelis", "image": "liet.png" },
        { "name": "ERGOM", "image": "ergom.png" },
        { "name": "EGI", "image": "egi.png" },
        { "name": "ELKO BIS", "image": "elkobis.png" },
        { "name": "SIMON", "image": "simon.png" }
    ]
}

const Partners: React.FC = () => {
    useEffect(() => { }, []);

    const classes = useStyles();

    const [selected, setSelected] = useState("all");

    const onClick = (selected: string) => (
        setSelected(selected)
    )

    return (
        <Box pt={2} pb={1} pl={6} pr={6}>
            <Box className={classes.largeTitle} textAlign="center">
                <FormattedMessage id="nav.partners" />
            </Box>
            <Grid container justify="center" alignContent="center">
                <Grid item xs={6} sm={2}>
                    <PrimaryButton labelText="partners.all" code="all" clickHandler={onClick} buttonEnabled={selected === "all" ? true : false} />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <PrimaryButton labelText="partners.telecommunications" code="telecommunications" clickHandler={onClick} buttonEnabled={selected === "telecommunications" ? true : false} />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <PrimaryButton labelText="partners.security" code="security" clickHandler={onClick} buttonEnabled={selected === "security" ? true : false} />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <PrimaryButton labelText="partners.materials" code="materials" clickHandler={onClick} buttonEnabled={selected === "materials" ? true : false} />
                </Grid>
            </Grid>
            <PartnerList title="partners.telecommunications" data={partners.telecommunications} show={selected === "all" || selected === "telecommunications" ? 'block' : 'none'} />
            <PartnerList title="partners.security" data={partners.security} show={selected === "all" || selected === "security" ? 'block' : 'none'} />
            <PartnerList title="partners.materials" data={partners.materials} show={selected === "all" || selected === "materials" ? 'block' : 'none'} />
        </Box>
    );
};

export default Partners;
